module.exports = __webpack_public_path__ + "img/box-heart.ec6ea999.svg";